import { render, staticRenderFns } from "./SurveyLayoff.vue?vue&type=template&id=25882479"
import script from "./SurveyLayoff.vue?vue&type=script&lang=js"
export * from "./SurveyLayoff.vue?vue&type=script&lang=js"
import style0 from "./SurveyLayoff.vue?vue&type=style&index=0&id=25882479&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports